"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentrySink = void 0;
const Sentry = __importStar(require("@sentry/react"));
const tracing_1 = require("@sentry/tracing");
const AppSettings_1 = __importDefault(require("../AppSettings"));
const types_1 = require("./types");
/**
 * SentrySink is responsible for forwarding Log.* statements on to the specified
 * Sentry project.
 *
 * The minimumLevel of Log to send should be "warn" or "error", so that we don't
 * blow through our monthly quota in a matter of minutes 🙃.
 */
class SentrySink extends types_1.LogSink {
    constructor({ minimumLevel }, options) {
        var _a, _b, _c;
        super({ minimumLevel });
        const release = (_b = (_a = AppSettings_1.default.getWebClientSentrySettingsRelease()) !== null && _a !== void 0 ? _a : AppSettings_1.default.getNextWebClientSentrySettingsRelease()) !== null && _b !== void 0 ? _b : undefined;
        let browserTracing;
        if (options.browserHistory) {
            const routingInstrumentation = Sentry.reactRouterV5Instrumentation(options.browserHistory);
            browserTracing = new tracing_1.BrowserTracing({
                routingInstrumentation,
            });
        }
        Sentry.init({
            dsn: options.dsn,
            environment: options.environment,
            release,
            integrations: browserTracing ? [browserTracing] : [],
            ignoreErrors: [
                "Non-Error promise rejection captured with value: Object Not Found Matching Id",
                ...(options.errorsToIgnore ? options.errorsToIgnore : []),
            ],
            tracesSampleRate: (_c = options.tracesSamplingRate) !== null && _c !== void 0 ? _c : 0.05, // fallback to 0.5%
            normalizeDepth: 10,
        });
    }
    next(logEntry) {
        // special case for Sentry. Anything that is an info log will be pushed
        // in breadcrumbs as they might still be useful, but don't eating into
        // out quota with their standalone own issue/event
        if (logEntry.level === "info") {
            Sentry.addBreadcrumb({
                type: "Info",
                level: "info",
                category: "@accurx/Log",
                message: typeof logEntry.message === "string"
                    ? logEntry.message
                    : logEntry.message.message,
                data: Object.assign({}, logEntry.tags),
            });
        }
        if (this.shouldHandleLogEntry(logEntry)) {
            Sentry.withScope(function (scope) {
                if (logEntry.fingerprint !== undefined &&
                    logEntry.fingerprint.length > 0) {
                    scope.setFingerprint(logEntry.fingerprint);
                }
                // add named structured contexts to Sentry issue
                if (logEntry.contexts !== undefined) {
                    logEntry.contexts.forEach((ctx) => scope.setContext(ctx.name, ctx.data));
                }
                // if a caught exception value was passed in, add it as its own context object
                if (logEntry.originalException !== undefined) {
                    scope.setContext("Original Error Details", parseOriginalException(logEntry.originalException));
                }
                // add custom tags to Sentry issue
                if (logEntry.tags !== undefined) {
                    for (const [tag, value] of Object.entries(logEntry.tags)) {
                        scope.setTag(tag, value);
                    }
                }
                if (typeof logEntry.message === "string") {
                    Sentry.captureMessage(logEntry.message, {
                        level: logEntry.level === "warn"
                            ? "warning"
                            : logEntry.level,
                    });
                }
                else if (logEntry.message instanceof Error) {
                    Sentry.captureException(logEntry.message);
                }
            });
        }
    }
}
exports.SentrySink = SentrySink;
/**
 * When a caught exception is supplied (which could be a value of any type),
 * this function will extract information from it such that it can be sent along
 * with any log.
 *
 * @param {unknown} error a value that caught by a try/catch
 */
function parseOriginalException(ex) {
    return ex instanceof Error
        ? {
            __type__: ex.name,
            __details__: {
                name: ex.name,
                message: ex.message,
                stack: ex.stack,
            },
        }
        : {
            __type__: "Non-Error object",
            __details__: Object.assign({}, ex),
        };
}
//# sourceMappingURL=SentrySink.js.map